import React from 'react';
import {
  WrapperBar,
  ProgressTrack,
  Bar,
  IndeterminateBar,
} from '../../../Common/StyledLoadingBar';

export const LoadingBar = ({ progress }) => {
  const percentage = Number.isFinite(progress.seriesPercentComplete)
    ? Math.min(100, Math.max(0, progress.seriesPercentComplete))
    : null;
  const hasPercentage = Number.isFinite(percentage);

  return (
    <WrapperBar>
      <ProgressTrack>
        <p className="percent">{hasPercentage ? `${Math.round(percentage)} %` : 'Loading…'}</p>
        {hasPercentage && !progress.seriesIsIndeterminate
          ? <Bar value={percentage} max={100} />
          : <IndeterminateBar className="indeterminate" />}
      </ProgressTrack>
    </WrapperBar>
  );
};
